import {backData, cancelData, passData, refuseData} from './approve.data.reasons'

const orderApproveDialogData = {
  chooseReason: {
    title: '选择原因',
    visible: false,
    currentField: null, // 需要保存选中值的文本框
    apiParams: {
      params: {riskType: null} // A 通过, C 取消, R 拒绝
    },
    data: [],
    // todo load these Data on the init step
    cancelData,
    refuseData,
    backData,
    passData
  },
  pointFinalApproverDialog: {
    title: '请选择终审审批人',
    visible: false,
    data: []
  },
  uploadAttachment: {
    title: '审批附件上传',
    visible: false,
    fileList: []
  },
  getC300VinInfo: {
    title: '车300车型识别',
    visible: false,
    apiParams: {
      params: {vin: null}
    },
    data: []
  },
  getC300EvaluationPrice: {
    title: '车300车辆估值',
    visible: false,
    apiParams: {
      dealerCode: null,
      mileage: null,
      firstregtime: null,
      mid: null,
      returnType: null,
      vin: null,
      che300Mid: null,
      color: null
    },
    data: []
  },
  chooseGpsStatus: {
    title: '选择审核结果',
    visible: false,
    allPass: false, // 每条GPS记录状态都是通过的标识
    currentRow: null,
    selectedArray: null,
    data: []
  },
  insureScanningFiles: {
    title: '确认操作 - 对应扫描件是否已收到',
    visible: false,
    saveInsuredParams: { // 保存确认扫描件的参数
      appCode: null,
      caLoanAfterInfoList: []
    },
    data: [] // 已确认的扫描件
  },
  favorite: {
    title: '面签字段',
    visible: false,
    data: {}
  }
}
export {
  orderApproveDialogData
}



// WEBPACK FOOTER //
// ./src/assets/js/page/approval/refs/approve.page.dialog.js